import { Gender, Relationship } from '../../enums';

export class PersonType {
  number: string;
  birthAgeInYears: number;
  birthDate: any;
  gender: Gender;
  relationshipWithPolicyHolder: Relationship;
}
